module.exports = __webpack_public_path__ + "img/CHEVRON_RIGHT.e5dcf896.svg";